import React, { useEffect, useMemo, useState } from "react";
import styles from "./index.module.scss";
import {
  AppSdkCallResult,
  clearStoredSdkLogs,
  getBridgeDebugInfo,
  getServiceCarInfo,
  getStoredSdkLogs,
  requestVehicleLocation,
} from "../common/js/rescueSdk";

function stringify(data: any) {
  return JSON.stringify(data, null, 2);
}

export default function SdkDebug() {
  const [latestResult, setLatestResult] = useState<AppSdkCallResult | null>(null);
  const [logs, setLogs] = useState<any[]>(() => getStoredSdkLogs());
  const [loadingMethod, setLoadingMethod] = useState("");
  const bridgeInfo = useMemo(() => getBridgeDebugInfo(), []);

  useEffect(() => {
    document.title = "救援 SDK 调试";
  }, []);

  async function runSdkCall(method: "car" | "location") {
    setLoadingMethod(method);
    const result = method === "car" ? await getServiceCarInfo() : await requestVehicleLocation();
    setLatestResult(result);
    setLogs(getStoredSdkLogs());
    setLoadingMethod("");
  }

  function handleClearLogs() {
    clearStoredSdkLogs();
    setLatestResult(null);
    setLogs([]);
  }

  return (
    <div className={styles.page}>
      <h1 className={styles.title}>救援 SDK 调试</h1>

      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>Bridge 状态</h2>
        <pre className={styles.pre}>{stringify(bridgeInfo)}</pre>
        <p className={styles.hint}>
          手机通过 whistle 代理到本地页面后，在 App WebView 内打开本页，点击按钮验证 C 端新接口。
        </p>
      </section>

      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>手动调用</h2>
        <div className={styles.actions}>
          <button className={styles.button} onClick={() => runSdkCall("car")}>
            {loadingMethod === "car" ? "调用中..." : "Service.getCarInfo"}
          </button>
          <button className={styles.button} onClick={() => runSdkCall("location")}>
            {loadingMethod === "location" ? "调用中..." : "Location.requestLocation"}
          </button>
          <button
            className={`${styles.button} ${styles.buttonSecondary}`}
            onClick={() => setLogs(getStoredSdkLogs())}
          >
            刷新日志
          </button>
          <button
            className={`${styles.button} ${styles.buttonSecondary}`}
            onClick={handleClearLogs}
          >
            清空日志
          </button>
        </div>
      </section>

      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>最近一次结果</h2>
        <pre className={styles.pre}>{latestResult ? stringify(latestResult) : "暂无调用结果"}</pre>
      </section>

      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>本地日志</h2>
        <pre className={styles.pre}>{logs.length ? stringify(logs) : "暂无日志"}</pre>
        <p className={styles.hint}>
          同步写入 console、localStorage.rescue_sdk_debug_logs 和 window.__RESCUE_SDK_LOGS__。
        </p>
      </section>
    </div>
  );
}
